import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { QuantityPerSizeStepDto } from '@/api-sdk';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles, loadingStyles, quantityTableStyles } from '@/styles';

import '../../../configuration/hsp/fg-hsp-label';
import './fg-quantity-table-quantity-input';

@customElement('fg-quantity-per-size-table')
@localized()
export class FgQuantityPerSizeTable extends LitElement {
  @property({ type: Array })
  options: QuantityPerSizeStepDto['options'] = [];

  @property({ type: Number })
  totalQuantity = 0;

  @property({ type: Number })
  hspMaximumQuantity?: number | null = 0;

  @property({ type: String })
  totalPrice?: string | null = null;

  @property({ type: Boolean })
  loading = false;

  render() {
    return html`
      <table class="quantities">
        <thead>
          <tr>
            <th class="amount">${t('labels.quantity')}</th>
            <th class="size">${t('labels.size')}</th>
            <th class="mobile-hidden">${t('labels.pricePerItem')}</th>
            <th class="mobile-show">${t('labels.pricePerItemMb')}</th>
            <th>${t('labels.total')}</th>
          </tr>
        </thead>

        <tbody>
          ${this.options &&
          this.options.map(option => {
            const { queryString, quantity, size, totalPrice, unitPrice } =
              option;

            return html`
              <tr class=${this.loading ? 'loading' : ''}>
                <td class="amount">
                  <fg-quantity-table-quantity-input
                    optionQueryString=${queryString}
                    .quantity=${quantity}
                  ></fg-quantity-table-quantity-input>
                </td>
                <td class="size">${size}</td>
                <td>
                  <span>${unitPrice}</span>
                </td>
                <td class="total-price">
                  <span>${totalPrice ?? '-'}</span>
                </td>
              </tr>
            `;
          })}
        </tbody>

        <tfoot>
          <tr class=${this.loading ? `loading` : ''}>
            <td colspan="4">
              <table>
                <tr class="total">
                  <td>
                    ${t(
                      'content.configurator.chooseQuantityStep.totalQuantity',
                      {
                        quantity: this.totalQuantity,
                      },
                    )}
                  </td>
                  <td>
                    <span>${this.totalPrice ?? '-'}</span>
                  </td>
                </tr>
                ${this.hspMaximumQuantity
                  ? html`
                      <tr>
                        <td>
                          <fg-hsp-label
                            .hspMaximumQuantity=${this.hspMaximumQuantity}
                          ></fg-hsp-label>
                        </td>
                        <td></td>
                      </tr>
                    `
                  : nothing}
                <!-- Todo: enable when information is available: https://jira.hosted-tools.com/browse/FGCOM-516 -->
                <!-- <tr class="profit">
                  <td>(HC) Voordeel: <em>Nog 50 stuks voor 12% korting</em></td>
                  <td>6% korting</td>
                </tr> -->
              </table>
            </td>
          </tr>
        </tfoot>
      </table>
    `;
  }

  static styles = [
    baseStyles,
    quantityTableStyles,
    loadingStyles,
    css`
      .mobile-hidden {
        display: none;
      }
      .mobile-show {
        display: table-cell;
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        .mobile-show {
          display: none;
        }
        .mobile-hidden {
          display: table-cell;
        }
      }
    `,
  ];
}
